import { Dialog, DialogProps, useTranslations } from "@bsm/component"

export const DeleteStudentDialog = (props: TProps) => {

    const [
        OK,
        CANCEL,
    ] = useTranslations(i18n);

    return (
        <Dialog
            title={"Delete student"}
            open={props.open}
            confirmation
            onClose={props.onClose}
            onCancel={props.onClose}
            onConfirm={props.onConfirm}
            btnOk={{ label: OK }}
            btnCancel={{ label: CANCEL }}
        >
            Are you sure you want to remove this student from scholarity ?
        </Dialog>
    )
}

const i18n = [
    "std_confirm",
    "std_cancel",
]

type TProps = Partial<DialogProps> 